let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iA3zH")).then(() => parcelRequire('398LT'));